<template>
    <div>
        <div class="modal fade" id="cropper-js-image-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Crop Image</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="close">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <div id="editor_container"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FilerobotImageEditor from 'filerobot-image-editor';
const { TABS, TOOLS } = FilerobotImageEditor;
export default {
    name   : 'image-cropper-js',
    props  : [],
    components: {},
    data() {
        return {
            imageURL: 'https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/photo-placeholder.png',
            croppedData: null,
            cropRatio: 1
        }
    },
    methods: {
        open(data){
            this.imageURL = data.img;
            this.cropRatio = data.cropRatio;
            $('#cropper-js-image-modal').modal('show');
            this.initEditor();
        },
        saveCroppedImage(imageBase64){
            this.$parent.storeCroppedImage(imageBase64);
        },
        close(){
            this.croppedData = null;
            $('#cropper-js-image-modal').modal('hide');
            this.imageURL = 'https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/photo-placeholder.png';
            $('#editor_container').empty();
        },
        initEditor(){
            const config = {
                source: this.imageURL,
                onSave: (editedImageObject, designState) => {
                    this.saveCroppedImage(editedImageObject.imageBase64);
                },
                annotationsCommon: {
                    fill: '#ff0000',
                },
                Text: { text: 'Type here...' },
                Rotate: { angle: 90, componentType: 'slider' },
                translations: {
                    profile: 'Profile',
                    coverPhoto: 'Cover photo',
                    facebook: 'Facebook',
                    socialMedia: 'Social Media',
                    fbProfileSize: '180x180px',
                    fbCoverPhotoSize: '820x312px',
                },
                Crop: {
                    ratio: 'custom',
                    presetsItems: [
                        {
                            titleKey: 'classicTv',
                            descriptionKey: '4:3',
                            ratio: 4 / 3,
                            // icon: CropClassicTv, // optional, CropClassicTv is a React Function component. Possible (React Function component, string or HTML Element)
                        },
                        {
                            titleKey: 'cinemascope',
                            descriptionKey: '21:9',
                            ratio: 21 / 9,
                            // icon: CropCinemaScope, // optional, CropCinemaScope is a React Function component.  Possible (React Function component, string or HTML Element)
                        },
                    ],
                    presetsFolders: [
                        {
                            titleKey: 'socialMedia', // will be translated into Social Media as backend contains this translation key
                            // icon: Social, // optional, Social is a React Function component. Possible (React Function component, string or HTML Element)
                            groups: [
                                {
                                    titleKey: 'facebook',
                                    items: [
                                        {
                                            titleKey: 'profile',
                                            width: 180,
                                            height: 180,
                                            descriptionKey: 'fbProfileSize',
                                        },
                                        {
                                            titleKey: 'coverPhoto',
                                            width: 820,
                                            height: 312,
                                            descriptionKey: 'fbCoverPhotoSize',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                tabsIds: [TABS.ADJUST, TABS.ANNOTATE, TABS.FINETUNE, TABS.FILTERS, TABS.RESIZE], // or ['Adjust', 'Annotate', 'Watermark']
                defaultTabId: TABS.ADJUST, // or 'Annotate'
            };

            const filerobotImageEditor = new FilerobotImageEditor(
                document.querySelector('#editor_container'),
                config,
            );
            filerobotImageEditor.render({
                onClose: (closingReason) => {
                    this.close();
                    filerobotImageEditor.terminate();
                },
            });
        }
    },
    mounted(){
        Bus.$on('emitImageForEditingToFileRobot', data => {
            this.open(data);
        });

        Bus.$on('closeEmitImageForEditingToFileRobot', data => {
            this.close();
        });
    }
}
</script>
